/**
 * TanStack Query hooks for `free-trial-first-10-000-conversions-free-30-days`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	freeTrialFirst10000ConversionsFree30DaysQueryKeys,
	type CreateFreeTrialFirst10000ConversionsFree30DaysBody,
	type ListFreeTrialFirst10000ConversionsFree30DaysResponse,
	type FreeTrialFirst10000ConversionsFree30DaysRow,
} from "./api";

export function useFreeTrialFirst10000ConversionsFree30DaysList(): UseQueryResult<ListFreeTrialFirst10000ConversionsFree30DaysResponse, Error> {
	return useQuery({
		queryKey: freeTrialFirst10000ConversionsFree30DaysQueryKeys.list(),
		queryFn: list,
	});
}

export function useFreeTrialFirst10000ConversionsFree30DaysCreate(): UseMutationResult<FreeTrialFirst10000ConversionsFree30DaysRow, Error, CreateFreeTrialFirst10000ConversionsFree30DaysBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: freeTrialFirst10000ConversionsFree30DaysQueryKeys.all });
		},
	});
}

export function useFreeTrialFirst10000ConversionsFree30DaysDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: freeTrialFirst10000ConversionsFree30DaysQueryKeys.all });
		},
	});
}
